<template>
  <div class="dj-case-page full-page" :style="'background: url(' + currentPageBg.bg + ') no-repeat center; ' + 'background-size: cover'">
    <!--<img class="page-bg" :src="currentPageBg.bg"/>-->
    <div class="page-mask" v-if="(currentGuideIdx === 1 && currentPageBg.idx === 1) || currentGuideIdx === 2 || currentGuideIdx === 3"></div>
    <div class="full-page page-content page-achievement" v-if="currentGuideIdx === 1">
      <div :class="currentPageBg.idx === 1 ? 'element-display': 'element-hide'">
        <div class="page-title">威龙电镀加工厂</div>
        <div class="page-sub-title">专业电镀加工厂</div>
        <div class="page-group dd-page-group">
          <div class="group-item dd-group-item left">
            <div class="item-img left">
              <img src="../../../assets/img/case/case-precent-icon-01.png"/>
            </div>
            <div class="item-content">
              <div class="item-title">55%</div>
              <div class="item-sub-title">减少沟通和纸张的使用</div>
            </div>
          </div>
          <div class="group-item dd-group-item left">
            <div class="item-img left">
              <img src="../../../assets/img/case/case-precent-icon-02.png"/>
            </div>
            <div class="item-content">
              <div class="item-title">60%</div>
              <div class="item-sub-title">降低数据汇总和分析时间</div>
            </div>
          </div>
          <div class="group-item dd-group-item left">
            <div class="item-img left">
              <img src="../../../assets/img/case/case-precent-icon-03.png"/>
            </div>
            <div class="item-content">
              <div class="item-title">35%</div>
              <div class="item-sub-title">降低次品率及次品成本</div>
            </div>
          </div>
          <div class="group-item dd-group-item left">
            <div class="item-img left">
              <img src="../../../assets/img/case/case-precent-icon-04.png"/>
            </div>
            <div class="item-content">
              <div class="item-title">35%</div>
              <div class="item-sub-title">工厂全面透明可视，<br/>协同效率提升</div>
            </div>
          </div>
          <div class="group-item dd-group-item left">
            <div class="item-img left">
              <img src="../../../assets/img/case/case-precent-icon-05.png"/>
            </div>
            <div class="item-content">
              <div class="item-title">22%</div>
              <div class="item-sub-title">人员生产率提升</div>
            </div>
          </div>
          <div class="group-item dd-group-item left">
            <div class="item-img left">
              <img src="../../../assets/img/case/case-precent-icon-06.png"/>
            </div>
            <div class="item-content">
              <div class="item-title">3%</div>
              <div class="item-sub-title">设备OEE提升</div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="page-carousel dd-page-carousel">
        <div class="carousel-item-block left" v-for="(item, index) in carouselImgList" :key="index">
          <div class="carousel-item" :class="currentPageBg.idx === item.idx ? 'carousel-item-active': ''" @click="choosePageBg(item)">
            <div class="carousel-img-sign" v-if="item.idx === 1">
              <icon class="carousel-img-sign-icon" name="exclamation"></icon>
            </div>
            <div class="carousel-item-mask" :class="currentPageBg.idx === item.idx ? 'carousel-item-mask-active': ''"></div>
            <img class="carousel-img" :src="item.icon"/>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="page-carousel-pad dd-page-carousel-pad">
        <div class="page-carousel-pad-content">
          <div class="carousel-pad-item-block dd-carousel-pad-item-block left" v-for="(item, index) in carouselImgList" :key="index">
            <div class="carousel-pad-item" :class="currentPageBg.idx === item.idx ? 'carousel-pad-item-active': ''" @click="choosePageBg(item)">
              <div class="carousel-img-sign" v-if="item.idx === 1">
                <icon class="carousel-img-sign-icon" name="exclamation"></icon>
              </div>
              <div class="carousel-item-mask" :class="currentPageBg.idx === item.idx ? 'carousel-item-mask-active': ''"></div>
              <img :src="item.icon"/>
              <div class="clear"></div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="carousel-button button-pre" @click="checkPageBefore"><i class="el-icon-arrow-left button-arrow-icon"></i></div>
        <div class="carousel-button button-next" @click="checkPageNext"><i class="el-icon-arrow-right button-arrow-icon"></i></div>
        <div class="clear"></div>
      </div>
    </div>
    <div class="full-page page-content page-problem" v-if="currentGuideIdx === 2">
      <div class="problem-group">
        <div class="problem-item">
          <div class="problem-title">人为抄数</div>
          <div class="problem-sub-title">要依赖人手，无法大量、密集、准时采集全部数据</div>
        </div>
        <div class="problem-item">
          <div class="problem-title">数据真伪</div>
          <div class="problem-sub-title">数据的真伪存疑</div>
        </div>
        <div class="problem-item">
          <div class="problem-title">数据实时性</div>
          <div class="problem-sub-title">大量数据无法即时到达相关人员手中。更不要说及时处理和应用了</div>
        </div>
      </div>
    </div>
    <div class="full-page page-content page-solution" v-if="currentGuideIdx === 3">
      <div class="solution-content w-long-solution-content">
        <div class="solution-diagram w-long-diagram">
          <img class="diagram-img" src="../../../assets/img/case/case-solution-diagram-02.png"/>
        </div>
        <div class="solution-feature dd-solution-feature">
          <div class="feature-title">系统功能</div>
          <div class="feature-group">
            <div class="feature-item left" v-for="(item, index) in featureList" :key="index">
              <img :src="item.icon"/>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../styles/page.scss'
export default {
  name: 'wLongPage',
  props: {
    currentGuideIdx: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      currentPageBg: {
        idx: 1,
        bg: require('../../../assets/img/case/case-page-bg-06.png')
      },
      carouselImgList: [
        {idx: 1, icon: require('../../../assets/img/case/dd/case-dd-page-bg-01.png'), bg: require('../../../assets/img/case/dd/case-dd-page-bg-01.png')},
        {idx: 2, icon: require('../../../assets/img/case/dd/case-dd-page-bg-02.jpg'), bg: require('../../../assets/img/case/dd/case-dd-page-bg-02.jpg')},
        {idx: 3, icon: require('../../../assets/img/case/dd/case-dd-page-bg-04.jpg'), bg: require('../../../assets/img/case/dd/case-dd-page-bg-04.jpg')},
        {idx: 4, icon: require('../../../assets/img/case/dd/case-dd-page-bg-05.jpg'), bg: require('../../../assets/img/case/dd/case-dd-page-bg-05.jpg')},
        {idx: 5, icon: require('../../../assets/img/case/dd/case-dd-page-bg-06.jpg'), bg: require('../../../assets/img/case/dd/case-dd-page-bg-06.jpg')},
        {idx: 6, icon: require('../../../assets/img/case/dd/case-dd-page-bg-07.jpg'), bg: require('../../../assets/img/case/dd/case-dd-page-bg-07.jpg')},
        {idx: 7, icon: require('../../../assets/img/case/dd/case-dd-page-bg-08.jpg'), bg: require('../../../assets/img/case/dd/case-dd-page-bg-08.jpg')},
        {idx: 8, icon: require('../../../assets/img/case/dd/case-dd-page-bg-09.jpg'), bg: require('../../../assets/img/case/dd/case-dd-page-bg-09.jpg')},
        {idx: 9, icon: require('../../../assets/img/case/dd/case-dd-page-bg-10.jpg'), bg: require('../../../assets/img/case/dd/case-dd-page-bg-10.jpg')}
      ],
      featureList: [
        {idx: 1, icon: require('../../../assets/img/case/case-feature-01.png')},
        {idx: 2, icon: require('../../../assets/img/case/case-feature-02.png')},
        {idx: 3, icon: require('../../../assets/img/case/case-feature-03.png')},
        {idx: 4, icon: require('../../../assets/img/case/case-feature-04.png')},
        {idx: 5, icon: require('../../../assets/img/case/case-feature-05.png')},
        {idx: 6, icon: require('../../../assets/img/case/case-feature-06.png')},
        {idx: 7, icon: require('../../../assets/img/case/case-feature-07.png')},
        {idx: 8, icon: require('../../../assets/img/case/case-feature-08.png')},
        {idx: 9, icon: require('../../../assets/img/case/case-feature-09.png')},
        {idx: 10, icon: require('../../../assets/img/case/case-feature-10.png')},
        {idx: 11, icon: require('../../../assets/img/case/case-feature-11.png')},
        {idx: 12, icon: require('../../../assets/img/case/case-feature-12.png')},
        {idx: 13, icon: require('../../../assets/img/case/case-feature-13.png')},
        {idx: 14, icon: require('../../../assets/img/case/case-feature-14.png')},
        {idx: 15, icon: require('../../../assets/img/case/case-feature-15.png')},
        {idx: 16, icon: require('../../../assets/img/case/case-feature-16.png')}
      ]
    }
  },
  methods: {
    choosePageBg (data) {
      this.currentPageBg.idx = data.idx
      this.currentPageBg.bg = data.bg
    },
    // 图片切换，上一张
    checkPageBefore () {
      let obj = this.carouselImgList[0]
      for (let i = 0; i < this.carouselImgList.length - 1; i++) {
        this.carouselImgList[i] = this.carouselImgList[i + 1]
        this.$set(this.carouselImgList, i, this.carouselImgList[i + 1])
      }
      this.$set(this.carouselImgList, this.carouselImgList.length - 1, obj)
    },
    // 图片切换，下一张
    checkPageNext () {
      let obj = this.carouselImgList[this.carouselImgList.length - 1]
      for (let i = this.carouselImgList.length - 1; i >= 1; i--) {
        this.$set(this.carouselImgList, i, this.carouselImgList[i - 1])
      }
      this.$set(this.carouselImgList, 0, obj)
    }
  }
}
</script>

<style scoped>
  .dd-page-group {
    max-width: 1000px;
  }
  .dd-group-item {
    width: 33%;
  }
  .dd-page-carousel {
    display: none;
  }
  .dd-page-carousel-pad {
    display: block;
    margin-top: 100px;
  }
  .dd-carousel-pad-item-block {
    width: 16.6%;
  }
  .w-long-solution-content {
    margin-top: 200px;
  }
  @media all and (max-width: 1430px) {
    .dd-page-carousel-pad {
      margin-top: 20px;
    }
    .dd-carousel-pad-item-block {
      width: 25%;
    }
  }
  @media all and (max-width: 1320px) {
    .dd-group-item {
      width: 50%;
    }
  }
  @media all and (max-width: 1050px) {
    .w-long-solution-content {
      margin-top: 150px;
    }
    .dd-solution-feature {
      margin-top: 10px;
    }
  }
  @media all and (max-width: 900px) {
    .dd-carousel-pad-item-block {
      width: 33.3%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/case/components/DDuPage.vue